import script from "./DutyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DutyModal.vue?vue&type=script&setup=true&lang=ts"

import "./DutyModal.vue?vue&type=style&index=0&id=8be5ae62&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8be5ae62"]])

export default __exports__